import { queryAlertDetailAtom } from "../alertDetail";
import { pathnameAtom } from "../common";
import { queryDailyAtom } from "../daily";
import { queryDailyDetailAtom } from "../dailyDetail";
import { queryHomeAtom } from "../home";
import { queryhourlyAtom } from "../hourly";
import { queryLifeStyleAtom } from "../lifestyleDetail";
import { queryRuhuKaalAtom } from "../rahuKaal";
import { querySunmoonAtom } from "../sunmoon";
import { jotaiStore } from "@/atoms/store.ts";

export const useApiMap = (params: any, options: any = {}) => {
  const { get, set } = jotaiStore;
  const { targetPath = "", key = "home" } = options;
  const pathname = get(pathnameAtom);
  const atomMap: any = {
    lifestyle: () => set(queryLifeStyleAtom, params),
    home: () => set(queryHomeAtom, params),
  };
  const baseMap = {
    "/home": () => set(queryHomeAtom, params),
    "/news": () => set(queryHomeAtom, params),
    "/news/detail": () => set(queryHomeAtom, params),
    "/now": () => set(queryHomeAtom, params),
    "/hourly": () => set(queryhourlyAtom, params),
    "/daily": () => set(queryDailyAtom, params),
    "/sun-moon": () => set(querySunmoonAtom, params),
    "/daily/detail": () => set(queryDailyDetailAtom, params),
    "/rahu-kaal": () => set(queryRuhuKaalAtom, params),
    "/hourly/alertdetail": () => set(queryAlertDetailAtom, params),
    "/daily/alertdetail": () => set(queryAlertDetailAtom, params),
    "/home/detail": () => set(queryAlertDetailAtom, params),
    "/now/detail": () => set(queryAlertDetailAtom, params),
  };
  const apiMap: any = {
    ...baseMap,
    [targetPath]: atomMap[key],
  };
  const matchKey = Object.keys(apiMap)
    .sort((a, b) => b.length - a.length)
    .find(key => pathname.startsWith(key));
  if (matchKey) {
    apiMap[matchKey]();
  }
};
